module.exports = __webpack_public_path__ + "img/Sleeves-Front-B9-Da-Ea-Gc.89ed17eb.png";